export function stripLabelQuotes(raw: string): string {
  const unquoted = stripWrappingQuotes(raw);
  if (/<[A-Za-z/][\s\S]*>|`/.test(unquoted)) {
    return unquoted.trim();
  }
  return unquoted
    .replace(/\\n/g, '\n')
    .replace(/[^\S\n]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .trim();
}

export function getMatchGroup(input: { match: RegExpMatchArray; index: number }): string | null {
  return input.match[input.index] ?? null;
}

export function getOptionalMatchGroup(input: {
  match: RegExpMatchArray | null;
  index: number;
}): string | null {
  return input.match?.[input.index] ?? null;
}

function stripWrappingQuotes(raw: string): string {
  const trimmed = raw.trim();
  const quotedMatch = trimmed.match(/^"([\s\S]*)"$/);
  return quotedMatch ? quotedMatch[1] ?? '' : trimmed;
}
